<template>
    <div
        :id="id"
        :class="{
            filled: filled,
            focused: focused,
            disabled: disabled,
            error: error,
            'no-label': !label,
        }"
        class="tl-input-text tl-input-number"
    >
        <div class="tl-input-wrapper">
            <input
                ref="input"
                :value="modelValue"
                type="number"
                :step="stepVal"
                :disabled="disabled"
                :maxlength="maxlength"
                @input="handleUpdate($event)"
                @focus="focused = true"
                @blur="focused = false"
            />
            <div
                v-if="label"
                class="tl-label"
            >
                <div>{{ label }}</div>
            </div>
        </div>
        <ErrorText
            v-if="error"
            :error="error"
        />
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import useTools from 'widget-components/utilities/tools'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'
import { isEmpty, isNil } from 'ramda'

const { wait } = useTools()

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    modelValue: Number,
    initialValue: Number,
    step: [Number, String],
    disabled: Boolean,
    focus: Boolean,
    maxlength: [Number, String],
    error: {
        type: [String, Boolean],
        default: undefined,
    },
    label: String,
    blockPath: Array,
})

const emit = defineEmits(['update:modelValue', 'submit'])

const input = ref(null)

const filled = computed(() => !isNaN(props.modelValue))
const focused = ref(false)
const label = computed(() => props.label)

const stepVal = computed(() => props.step || 1)

const handleUpdate = (ev) => {
    const value = isNil(ev.target.value) ? '' : parseFloat(ev.target.value)
    emit('update:modelValue', value)
}

onMounted(async () => {
    if (props.focus) {
        await wait(800)
        input.value?.focus()
    }

    if (!isNil(props.initialValue) && !isEmpty(props.initialValue)) {
        emit('update:modelValue', props.initialValue)
    }
})
</script>

<style scoped lang="sass">
@import '../InputText/InputText.sass'
</style>
